/* SACLUXE — theme.js */
'use strict';

const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const M1 = 80000;  // 800 MAD — livraison offerte (matches cart-drawer.liquid m1)
let prevTotal = null;

function formatMAD(cents) {
  const fmt = window.Shopify && window.Shopify.moneyFormat;
  const n = (cents / 100).toFixed(2);
  if (fmt) {
    return fmt
      .replace(/\{\{amount\}\}/g, n)
      .replace(/\{\{amount_with_comma_separator\}\}/g, n.replace('.', ','))
      .replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents / 100))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, String(Math.round(cents / 100)));
  }
  return n + ' dh';
}

/* -- Cart Drawer -------------------------------------------- */
const CartDrawer = (() => {
  const SVG_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  const SVG_PLUS  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function open() {
    $('#cart-overlay')?.classList.add('show');
    $('#cart-drawer')?.classList.add('open');
    document.body.classList.add('cart-open');
    // Re-evaluate the shipping bar on open (reflects a free-delivery grant).
    fetch('/cart.js').then(r => r.json()).then(c => updateProgress(c.total_price)).catch(() => {});
  }
  function close() {
    $('#cart-overlay')?.classList.remove('show');
    $('#cart-drawer')?.classList.remove('open');
    document.body.classList.remove('cart-open');
  }
  function updateBadge(n) {
    $$('.cart-pip').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }
  function showToast(html) {
    let toast = document.getElementById('milestone-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'milestone-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.remove('show');
    void toast.offsetWidth;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('show'), 3800);
  }

  function freeShipGranted() {
    try { return sessionStorage.getItem('sx_freeship_active') === '1'; }
    catch (e) { return false; }
  }

  function updateProgress(totalCents) {
    const prev = prevTotal;
    prevTotal = totalCents;

    // Livraison offerte dès 800 dh (M1) — sinon 45 dh. Le pop-up exit-intent
    // (freeShipGranted) peut aussi débloquer la gratuité.
    const unlocked = totalCents >= M1 || freeShipGranted();

    // Animate fill bar (single milestone: free shipping at M1)
    const pct = unlocked ? 100 : Math.min(100, totalCents / M1 * 100);
    const track = $('.ship-track');
    const bar = $('.ship-fill');
    if (track) track.style.setProperty('--pct', pct + '%');
    if (bar) { bar.classList.remove('animating'); void bar.offsetWidth; bar.classList.add('animating'); }

    // Status text — mirrors the server-rendered markup in cart-drawer.liquid
    const msg = $('.ship-status');
    if (msg) {
      if (unlocked) {
        msg.innerHTML = '<span class="ship-unlocked">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><polyline points="20 6 9 17 4 12"/></svg>'
          + ' Livraison offerte débloquée</span>';
      } else {
        var remaining = Math.ceil((M1 - totalCents) / 100);
        msg.innerHTML = 'Plus que <b>' + remaining + ' dh</b> pour la livraison offerte 🚚';
      }
    }

    // Single endpoint milestone dot (free shipping)
    const stop = $('.ship-stop--last');
    if (stop) {
      const was = stop.classList.contains('reached');
      const is  = unlocked;
      stop.classList.toggle('reached', is);
      if (is && !was) {
        const dot = stop.querySelector('.ship-dot');
        if (dot) { dot.classList.remove('pop'); void dot.offsetWidth; dot.classList.add('pop'); }
      }
    }

    // No threshold toast — delivery is always free (Livraison gratuite partout au Maroc).
  }

  function updateSubtotal(totalCents) {
    const el = $('#cart-subtotal');
    if (el) el.textContent = formatMAD(totalCents);
    updateProgress(totalCents);
  }

  function imgUrl(url) {
    if (!url) return null;
    return String(url).replace(/(\.[^.?]+)(\?|$)/, '_160x$1$2');
  }

  function renderItem(item) {
    const imgTag = item.image
      ? '<img src="' + esc(imgUrl(item.image)) + '" alt="' + esc(item.product_title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">'
      : '<svg viewBox="0 0 60 75" fill="none" stroke="currentColor" stroke-width="1" style="opacity:.25;width:36px;height:45px"><rect x="5" y="22" width="50" height="48" rx="4"/><path d="M15 22 C15 7 45 7 45 22"/></svg>';
    const varHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="var">' + esc(item.variant_title) + '</div>' : '';
    return '<div class="cart-item" data-key="' + esc(item.key) + '">' +
      '<div class="thumb">' + imgTag + '</div>' +
      '<div class="info">' +
        '<div class="name">' + esc(item.product_title) + '</div>' + varHtml +
        '<div class="row">' +
          '<div class="qty-mini">' +
            '<button class="cart-qty-btn" data-key="' + esc(item.key) + '" data-delta="-1" aria-label="Moins">' + SVG_MINUS + '</button>' +
            '<span class="v">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + esc(item.key) + '" data-delta="1" aria-label="Plus">' + SVG_PLUS + '</button>' +
          '</div>' +
          '<div class="price">' + formatMAD(item.final_line_price) + '</div>' +
        '</div>' +
        '<button class="rem cart-rem" data-key="' + esc(item.key) + '">Retirer</button>' +
      '</div></div>';
  }

  function renderEmptyState(drawer) {
    ['.cd-bag-header', '#cart-prog', '#cart-items', '.drawer-items', '.upsell', '.gift-toggle', '#cart-foot', '.cd-body', '.cd-mob-upsell'].forEach(sel => {
      const el = drawer.querySelector(sel);
      if (el) el.style.display = 'none';
    });
    let emptyEl = drawer.querySelector('.empty-cart');
    if (!emptyEl) {
      emptyEl = document.createElement('div');
      emptyEl.className = 'empty-cart';
      emptyEl.innerHTML =
        '<h4>Votre panier est vide</h4>' +
        '<p style="font-size:13px">Decouvrez nos nouveautes et composez votre kit.</p>' +
        '<button class="btn btn-primary drawer-close" style="margin-top:18px">Continuer mes achats</button>';
      const head = drawer.querySelector('.drawer-head');
      if (head) head.insertAdjacentElement('afterend', emptyEl);
      else drawer.appendChild(emptyEl);
    }
    emptyEl.style.display = '';
  }

  function renderCart(cart) {
    updateBadge(cart.item_count);
    const drawer = $('#cart-drawer');
    if (!drawer) return;

    if (cart.item_count === 0) {
      renderEmptyState(drawer);
      return;
    }

    const emptyEl = drawer.querySelector('.empty-cart');
    if (emptyEl) emptyEl.style.display = 'none';
    ['.cd-bag-header', '#cart-prog', '.upsell', '.gift-toggle', '#cart-foot', '.cd-body', '.cd-mob-upsell'].forEach(sel => {
      const el = drawer.querySelector(sel);
      if (el) el.style.display = '';
    });

    let itemsEl = drawer.querySelector('#cart-items');
    if (!itemsEl) {
      itemsEl = document.createElement('div');
      itemsEl.id = 'cart-items';
      itemsEl.className = 'drawer-items';
      const prog = drawer.querySelector('#cart-prog');
      if (prog) prog.insertAdjacentElement('afterend', itemsEl);
      else {
        const head = drawer.querySelector('.drawer-head');
        if (head) head.insertAdjacentElement('afterend', itemsEl);
        else drawer.insertAdjacentElement('afterbegin', itemsEl);
      }
    }
    itemsEl.style.display = '';
    itemsEl.innerHTML = cart.items.map(renderItem).join('');

    let foot = drawer.querySelector('#cart-foot');
    if (!foot) {
      foot = document.createElement('div');
      foot.id = 'cart-foot';
      foot.className = 'cart-foot';
      foot.innerHTML =
        '<div class="sub">' +
          '<span class="lab">Sous-total</span>' +
          '<span class="val" id="cart-subtotal"></span>' +
        '</div>' +
        '<a href="/checkout" class="btn btn-primary btn-block">Passer au paiement</a>' +
        '<button class="btn btn-secondary btn-block cart-continue">Continuer mes achats</button>';
      drawer.appendChild(foot);
    }
    updateSubtotal(cart.total_price);
  }

  async function refresh() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      renderCart(cart);
    } catch (e) { console.error('[CartDrawer]', e); }
  }

  async function changeQty(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('change failed ' + res.status);
      renderCart(await res.json());
    } catch (e) { console.error('[CartDrawer]', e); }
  }

  async function addItem(variantId, qty) {
    if (!qty) qty = 1;
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!addRes.ok) throw new Error('add failed ' + addRes.status);
      const cart = await (await fetch('/cart.js')).json();
      renderCart(cart);
      open();
    } catch (e) { console.error('[CartDrawer]', e); }
  }

  function init() {
    document.addEventListener('click', e => {
      if (e.target.closest('#cart-btn, .cart-trigger')) { e.preventDefault(); open(); }
    });
    $('#cart-overlay')?.addEventListener('click', close);
    document.addEventListener('click', e => {
      if (e.target.closest('#drawer-close, .drawer-close, .cart-continue')) close();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    document.addEventListener('click', e => {
      const btn = e.target.closest('.cart-qty-btn');
      if (!btn || !btn.closest('#cart-drawer')) return;
      const key = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta, 10);
      const qtyEl = btn.closest('.qty-mini')?.querySelector('.v');
      const cur = parseInt(qtyEl?.textContent || '1', 10);
      const newQty = Math.max(delta < 0 ? 1 : 0, cur + delta);
      if (qtyEl) qtyEl.textContent = newQty;
      const item = btn.closest('.cart-item');
      if (item) item.style.opacity = '0.45';
      changeQty(key, newQty);
    });

    document.addEventListener('click', e => {
      const btn = e.target.closest('.cart-rem');
      if (!btn || !btn.closest('#cart-drawer')) return;
      const item = btn.closest('.cart-item');
      if (item) { item.style.transition = 'opacity 0.15s'; item.style.opacity = '0'; }
      changeQty(btn.dataset.key, 0);
    });

    document.addEventListener('click', e => {
      const btn = e.target.closest('.upsell-add');
      if (!btn || !btn.closest('#cart-drawer')) return;
      addItem(parseInt(btn.dataset.variant));
    });
    document.addEventListener('click', e => {
      if (!e.target.closest('.gift-toggle') || !e.target.closest('#cart-drawer')) return;
      close(); openGiftNote();
    });
  }

  return { init, open, close, addItem, refresh, updateBadge };
})();

/* -- Search Overlay ----------------------------------------- */
const SearchOverlay = (() => {
  let debounce, controller;

  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sized(u) { return u ? u + (u.includes('?') ? '&' : '?') + 'width=120' : ''; }

  function searchBase() {
    return $('#search-overlay form')?.getAttribute('action') || '/search';
  }
  function render(html) {
    const box = $('#search-results');
    if (!box) return;
    box.innerHTML = html;
    box.hidden = !html;
  }
  function clear() { render(''); }

  async function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    const suggest = searchBase().replace(/\/search\/?$/, '/search') + '/suggest.json';
    const url = suggest + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    try {
      const res = await fetch(url, { signal: controller.signal });
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      if (!products.length) {
        render('<p class="srch-empty">Aucun produit pour « ' + esc(q) + ' »</p>');
        return;
      }
      let html = '';
      products.forEach(p => {
        const img = (p.featured_image && p.featured_image.url) || p.image || '';
        const cents = Math.round(parseFloat(p.price_min || p.price || '0') * 100);
        const thumb = img
          ? '<img src="' + esc(sized(img)) + '" alt="" loading="lazy">'
          : '<span class="srch-noimg">S</span>';
        html += '<a class="srch-item" href="' + esc(p.url) + '" role="option">' +
          '<span class="srch-thumb">' + thumb + '</span>' +
          '<span class="srch-meta">' +
            '<span class="srch-title">' + esc(p.title) + '</span>' +
            '<span class="srch-price">' + formatMAD(cents) + '</span>' +
          '</span></a>';
      });
      html += '<a class="srch-all" href="' + searchBase() + '?q=' + encodeURIComponent(q) + '">Voir tous les résultats</a>';
      render(html);
    } catch (err) {
      if (err.name !== 'AbortError') clear();
    }
  }

  function open() {
    const overlay = $('#search-overlay');
    const btn = $('#search-btn');
    if (!overlay) return;
    overlay.classList.add('open');
    document.body.classList.add('search-open');
    btn?.setAttribute('aria-expanded', 'true');
    setTimeout(() => { $('#search-input')?.focus(); }, 80);
  }
  function close() {
    const overlay = $('#search-overlay');
    const btn = $('#search-btn');
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.classList.remove('search-open');
    btn?.setAttribute('aria-expanded', 'false');
    clearTimeout(debounce);
    if (controller) controller.abort();
    const input = $('#search-input');
    if (input) input.value = '';
    clear();
  }
  function init() {
    document.addEventListener('click', e => {
      if (e.target.closest('#search-btn')) { e.preventDefault(); open(); return; }
      if (e.target.closest('#srch-close')) { close(); return; }
      const overlay = $('#search-overlay');
      if (overlay?.classList.contains('open') && e.target === overlay) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && document.body.classList.contains('search-open')) close();
    });
    const input = $('#search-input');
    input?.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { clear(); return; }
      render('<p class="srch-loading">Recherche…</p>');
      debounce = setTimeout(() => run(q), 220);
    });
  }
  return { init, open, close };
})();

/* -- Mobile Menu -------------------------------------------- */
const MobileMenu = (() => {
  function open() {
    $('#mobile-menu')?.classList.add('open');
    document.body.classList.add('menu-open');
    $('#hamburger-btn')?.setAttribute('aria-expanded', 'true');
  }
  function close() {
    $('#mobile-menu')?.classList.remove('open');
    document.body.classList.remove('menu-open');
    $('#hamburger-btn')?.setAttribute('aria-expanded', 'false');
  }
  /* INERT: the mobile drawer is now driven entirely by the single-owner engine in
     sections/header.liquid. Binding handlers here too would make two controllers
     race to open/close the drawer — the original "won't close / page frozen" bug.
     Kept as a no-op so the MobileMenu.init() call site stays valid. */
  function init() {}
  return { init, open, close };
})();

/* -- Quick Shop Modal --------------------------------------- */
const QuickShop = (() => {
  function getModal() { return $('#quick-shop-modal'); }
  function open() { getModal()?.classList.add('open'); document.body.classList.add('modal-open'); }
  function close() { getModal()?.classList.remove('open'); document.body.classList.remove('modal-open'); }

  // In stock = Shopify's `available` flag. The /products.js API never exposes
  // inventory_quantity, so `available` is the only reliable signal here. With
  // inventory tracked + policy "stop selling when out of stock", it flips to
  // false the moment the counter hits 0. Matches the PDP logic exactly.
  function inStock(v) {
    return !!v && v.available;
  }
  // Is ANY variant of a given colour value still in stock?
  function colorInStock(p, colIdx, val) {
    return (p.variants || []).some(function (v) {
      return v['option' + (colIdx + 1)] === val && v.available;
    });
  }

  // Map a colour-option name to a usable CSS colour (option1 is rarely a valid CSS keyword).
  function swatchColor(name) {
    const k = String(name || '').toLowerCase().trim();
    if (k.indexOf('/') !== -1) {
      const p = k.split('/');
      return 'linear-gradient(135deg, ' + swatchColor(p[0]) + ' 0 48%, ' + swatchColor(p[1]) + ' 52% 100%)';
    }
    const map = {
      camel:'#C68A4E', noir:'#22201D', black:'#22201D', cognac:'#9C5A2C', taupe:'#A99A86',
      beige:'#D9CBB3', sable:'#D8C9A8', nude:'#D8C2A8', marron:'#5A3B23', brown:'#5A3B23',
      chocolat:'#4A2F1E', moka:'#6F4E37', blanc:'#EFEAE0', white:'#EFEAE0', ivoire:'#EFE7D6',
      creme:'#EADED0', gris:'#8C8881', grey:'#8C8881', gray:'#8C8881', rouge:'#8E2B2B', red:'#8E2B2B',
      bordeaux:'#5A1F2B', bleu:'#27374D', blue:'#27374D', marine:'#1F2A3C', vert:'#3B4A37', green:'#3B4A37',
      rose:'#C98C86', or:'#C9A84C', gold:'#C9A84C', argent:'#C2C2C2', silver:'#C2C2C2',
      'doré':'#C9A84C', dore:'#C9A84C'
    };
    if (map[k]) return map[k];
    if (/^#?[0-9a-f]{3}([0-9a-f]{3})?$/i.test(k)) return k.charAt(0) === '#' ? k : '#' + k;
    return '#C9BCA8';
  }

  // FR/EN colour synonym groups — lets a "Noir" variant match a "Black.png" file
  // (same approach as the PDP colour-filtered gallery).
  const QS_COLOR_GROUPS = [
    ['noir','black','onyx'],['blanc','white','ivoire','ivory'],['creme','cream','craie'],
    ['beige','sable','sand'],['nude'],['taupe'],['camel','fauve'],['cognac'],
    ['moka','mocha'],['chocolat','chocolate'],['marron','brun','brown','tan'],
    ['gris','grey','gray'],['olive','kaki','khaki'],['vert','green'],
    ['bleu','blue','navy','marine'],['bordeaux','burgundy','vin','wine'],
    ['rouge','red'],['rose','pink'],['orange'],['jaune','yellow'],
    ['dore','gold'],['argent','silver'],['violet','purple','prune']
  ];
  function qsNormText(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function qsNormKey(s)  { return qsNormText(s).replace(/ /g, ''); }
  function qsHasWord(t, w) { return new RegExp('(^| )' + w + '($| )').test(t); }
  function qsTokensFor(val) {
    const v = qsNormKey(val); const toks = v ? [v] : [];
    QS_COLOR_GROUPS.forEach(g => { if (g.indexOf(v) !== -1) g.forEach(t => { if (toks.indexOf(t) === -1) toks.push(t); }); });
    return toks;
  }
  function qsSized(u) { return u ? u.replace(/(\.[^.\/?]+)(\?|$)/, '_800x$1$2') : u; }

  function buildQS(p, cv, galleryMap, swatchMap) {
    // Identify option indices
    const COL_RE = /couleur|color|colour/i;
    const SIZ_RE = /taille|size|format|pointure|dimension/i;
    let colIdx = -1, sizIdx = -1;
    // /products/handle.js returns options as objects {name,values}; older shops
    // return plain strings — handle both.
    (p.options || []).forEach((o, i) => {
      const name = (o && typeof o === 'object') ? (o.name || '') : o;
      if (COL_RE.test(name) && colIdx < 0) colIdx = i;
      else if (SIZ_RE.test(name) && sizIdx < 0) sizIdx = i;
    });

    // Unique color values → swatches
    let swatches = '', firstName = '';
    const colorVals = [];
    if (colIdx >= 0) {
      const seen = colorVals;
      p.variants.forEach(v => {
        const val = v['option' + (colIdx + 1)] || '';
        if (!val || seen.indexOf(val) >= 0) return;
        seen.push(val);
        const isFirst = seen.length === 1;
        if (isFirst) firstName = val;
        const colOk = colorInStock(p, colIdx, val);
        // The merchant's ASSIGNED colour (Liquid-resolved swatch_color / swatch-hex),
        // falling back to the name→hex guess when no map was handed in.
        const swCol = (swatchMap && swatchMap[val]) ? swatchMap[val] : swatchColor(val);
        swatches += '<button class="swatch lg qs-swatch' + (isFirst ? ' active' : '') + (colOk ? '' : ' is-oos') + '" style="background:' + swCol + '" data-optidx="' + colIdx + '" data-optval="' + val.replace(/"/g, '') + '" aria-label="' + val + (colOk ? '' : ' \u2014 \u00e9puis\u00e9') + '" type="button"></button>';
      });
    }

    // Unique size values → pill buttons
    let sizes = '';
    if (sizIdx >= 0) {
      const seen = [];
      p.variants.forEach(v => {
        const val = v['option' + (sizIdx + 1)] || '';
        if (!val || seen.indexOf(val) >= 0) return;
        seen.push(val);
        const isFirst = seen.length === 1;
        sizes += '<button class="qs-size-btn' + (isFirst ? ' active' : '') + '" data-optidx="' + sizIdx + '" data-optval="' + val.replace(/"/g, '') + '" type="button">' + val + '</button>';
      });
    }

    // ---- Photo carousel (colour-filtered) -------------------------------
    let imgList = (p.media || []).filter(m => m.media_type === 'image' && m.src)
      .map(m => ({ src: m.src, alt: m.alt || '' }));
    if (!imgList.length) imgList = (p.images || []).map(s => ({ src: s, alt: '' }));
    if (!imgList.length && p.featured_image) imgList = [{ src: p.featured_image, alt: p.title }];

    const multiColor = colorVals.length > 1;
    const colTok = colorVals.map(v => ({ value: v, tokens: qsTokensFor(v) }));
    function classifyImg(alt, src) {
      if (!multiColor) return '';
      const file = String(src || '').split('?')[0].split('/').pop();
      // 1) PRIMARY: explicit per-colour gallery map (variant custom.gallery, from Liquid)
      if (galleryMap) {
        for (const color in galleryMap) {
          if ((galleryMap[color] || []).indexOf(file) !== -1) return color;
        }
        // not in any gallery → fall through to heuristic (treated as shared if no match)
      }
      // 2) Fallback: colour word in alt text / filename
      const text = qsNormText(alt) + ' ' + qsNormText(file);
      let best = '', bestLen = 0;
      colTok.forEach(vr => vr.tokens.forEach(t => {
        if (t && t.length > bestLen && qsHasWord(text, t)) { best = vr.value; bestLen = t.length; }
      }));
      return best;
    }

    let carInner;
    if (imgList.length) {
      const slides = imgList.map((im, i) =>
        '<div class="qs-slide' + (i === 0 ? ' active' : '') + '" data-color="' + classifyImg(im.alt, im.src).replace(/"/g, '') + '">'
        + '<img src="' + qsSized(im.src) + '" alt="' + String(im.alt || p.title).replace(/"/g, '') + '" loading="lazy">'
        + '</div>'
      ).join('');
      const navL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><polyline points="15 18 9 12 15 6"/></svg>';
      const navR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><polyline points="9 18 15 12 9 6"/></svg>';
      carInner = '<div class="qs-car">'
        + '<div class="qs-track">' + slides + '</div>'
        + '<button class="qs-nav qs-prev" type="button" aria-label="Pr\u00e9c\u00e9dent">' + navL + '</button>'
        + '<button class="qs-nav qs-next" type="button" aria-label="Suivant">' + navR + '</button>'
        + '<div class="qs-counter"><span class="qs-cur">01</span>/<span class="qs-tot">' + (imgList.length < 10 ? '0' : '') + imgList.length + '</span></div>'
        + '<div class="qs-dots"></div>'
        + '</div>';
    } else {
      carInner = '<svg viewBox="0 0 120 150" fill="none" stroke="currentColor" stroke-width="1.2" opacity=".25"><rect x="15" y="52" width="90" height="84" rx="7"/><path d="M35 52 C35 28 85 28 85 52"/></svg>';
    }

    const cap = (cv.compare_at_price && cv.compare_at_price > cv.price) ? cv.compare_at_price : 0;
    const pct = cap ? Math.round((cap - cv.price) / cap * 100) : 0;
    const priceHtml = '<span class="qs-amount" id="qs-price" data-cents="' + cv.price + '">' + formatMAD(cv.price) + '</span>'
      + '<span class="qs-was" id="qs-was"' + (cap ? '' : ' hidden') + '>' + (cap ? formatMAD(cap) : '') + '</span>'
      + '<span class="qs-save" id="qs-save"' + (cap ? '' : ' hidden') + '>-' + pct + '%</span>';

    const minus = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    const plus = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    const truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    const ret = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 9 8 9"/></svg>';
    const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

    return '<div class="qs-grid">'
      + '<div class="qs-art">' + carInner + '</div>'
      + '<div class="qs-info">'
      +   '<span class="eyebrow qs-eyebrow">Apercu rapide</span>'
      +   '<div class="qs-head">'
      +     '<h3 class="qs-title">' + p.title + '</h3>'
      +     '<div class="qs-price">' + priceHtml + '</div>'
      +   '</div>'
      +   '<div class="qs-hr"></div>'
      +   '<div class="qs-controls">'
      +     (swatches ? '<div class="qs-block qs-color"><div class="lbl">Couleur \u2014 <b class="qs-cname">' + firstName + '</b></div><div class="swatch-row">' + swatches + '</div></div>' : '')
      +     (sizes ? '<div class="qs-block qs-size-block"><div class="lbl">Taille</div><div class="size-row">' + sizes + '</div></div>' : '')
      +     '<div class="qs-block qs-qtyb">'
      +       '<div class="lbl">Quantit\u00e9</div>'
      +       '<div class="qty"><button class="qs-qty-minus" aria-label="Moins">' + minus + '</button><span class="v qs-qty-val">1</span><button class="qs-qty-plus" aria-label="Plus">' + plus + '</button></div>'
      +     '</div>'
      +   '</div>'
      +   '<div class="qs-actions">'
      +     '<div class="qs-oos-note' + (inStock(cv) ? '' : ' show') + '" data-qs-oos role="status" aria-live="polite"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="16" height="16"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16.5" x2="12" y2="16.6"/></svg><span>' + (multiColor ? 'Cette couleur est en rupture de stock.' : 'Cet article est en rupture de stock.') + '</span></div>'
      +     '<button class="btn btn-primary btn-block qs-atc"' + (inStock(cv) ? '' : ' disabled') + ' data-variant-id="' + cv.id + '">' + (inStock(cv) ? 'Ajouter au panier' : 'Rupture de stock') + '</button>'
      +     '<button type="button" class="btn btn-cod btn-block qs-cod"' + (inStock(cv) ? '' : ' style="display:none"') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16" style="margin-right:9px"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Commander \u00e0 la livraison</button>'
      +   '</div>'
      +   '<div class="qs-foot">'
      +     '<div class="qs-trust"><span>' + truck + ' Livraison 48h</span><span>' + ret + ' Retours 14j</span></div>'
      +     '<a href="/products/' + p.handle + '" class="qs-viewlink">Voir le produit ' + arrow + '</a>'
      +   '</div>'
      + '</div></div>';
  }

  function bindQS(p, galleryMap, pairs) {
    const modal = getModal();
    if (!modal) return;

    const numOpts = (p.options || []).length;
    const cv0 = p.variants[0];
    // One selected value per option slot (initialised from the first variant)
    const selOpts = cv0
      ? Array.from({length: numOpts}, (_, i) => cv0['option' + (i + 1)] || null)
      : [];
    const qtyVal = modal.querySelector('.qs-qty-val');

    // ---- Carousel controller (fade slides, colour-filtered) -------------
    const car = modal.querySelector('.qs-car');
    let carCtl = null;
    if (car) {
      const slidesAll = $$('.qs-slide', car);
      const dotsWrap  = car.querySelector('.qs-dots');
      const counter   = car.querySelector('.qs-counter');
      const curEl     = car.querySelector('.qs-cur');
      const totEl     = car.querySelector('.qs-tot');
      const prevB     = car.querySelector('.qs-prev');
      const nextB     = car.querySelector('.qs-next');
      let visible = slidesAll.slice();
      let idx = 0;
      const norm = s => String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');
      const pad  = n => (n < 10 ? '0' : '') + n;
      // Colours that have an explicit gallery → show ONLY their images (no shared leak)
      const MANUAL_KEYS = galleryMap ? Object.keys(galleryMap).map(norm) : [];

      function render() {
        slidesAll.forEach(s => s.classList.remove('active'));
        if (!visible.length) return;
        if (idx >= visible.length) idx = 0;
        if (idx < 0) idx = visible.length - 1;
        visible[idx].classList.add('active');
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          visible.forEach((s, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            if (i === idx) b.className = 'active';
            b.addEventListener('click', () => { idx = i; render(); });
            dotsWrap.appendChild(b);
          });
        }
        if (curEl) curEl.textContent = pad(idx + 1);
        if (totEl) totEl.textContent = pad(visible.length);
        const one = visible.length <= 1;
        [prevB, nextB].forEach(b => { if (b) b.hidden = one; });
        if (dotsWrap) dotsWrap.style.display = one ? 'none' : '';
        if (counter)  counter.style.display  = one ? 'none' : '';
      }
      function go(d) { idx = (idx + d + visible.length) % visible.length; render(); }
      prevB?.addEventListener('click', () => go(-1));
      nextB?.addEventListener('click', () => go(1));

      let sx = 0;
      car.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      });

      carCtl = {
        filterColor(val) {
          const k = norm(val);
          const kManual = MANUAL_KEYS.indexOf(k) !== -1;
          const matched = slidesAll.filter(s => {
            const c = norm(s.getAttribute('data-color'));
            if (kManual) return c === k;   // explicit gallery → only its own images
            return !c || c === k;          // else own colour OR shared image
          });
          visible = matched.length ? matched : slidesAll.slice();
          idx = 0; render();
        }
      };
      render();
      const activeSw = modal.querySelector('.qs-swatch.active');
      if (activeSw) carCtl.filterColor(activeSw.dataset.optval);
    }

    function findVariant() {
      return p.variants.find(v =>
        selOpts.every((val, i) => val === null || v['option' + (i + 1)] === val)
      ) || p.variants[0];
    }

    function applyVariant(v) {
      const priceEl = $('#qs-price', modal);
      if (priceEl) { priceEl.textContent = formatMAD(v.price); priceEl.dataset.cents = v.price; }
      const cap = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
      const wasEl = $('#qs-was', modal), saveEl = $('#qs-save', modal);
      if (wasEl) { wasEl.hidden = !cap; wasEl.textContent = cap ? formatMAD(cap) : ''; }
      if (saveEl) { saveEl.hidden = !cap; if (cap) saveEl.textContent = '-' + Math.round((cap - v.price) / cap * 100) + '%'; }
      const ok  = inStock(v);
      const btn = modal.querySelector('.qs-atc');
      if (btn) { btn.dataset.variantId = v.id; btn.disabled = !ok; btn.textContent = ok ? 'Ajouter au panier' : 'Rupture de stock'; }
      const codBtn = modal.querySelector('.qs-cod');
      if (codBtn) codBtn.style.display = ok ? '' : 'none';
      const oosNote = modal.querySelector('[data-qs-oos]');
      if (oosNote) oosNote.classList.toggle('show', !ok);
    }

    $$('.qs-swatch', modal).forEach(sw => {
      sw.addEventListener('click', () => {
        selOpts[parseInt(sw.dataset.optidx)] = sw.dataset.optval;
        $$('.qs-swatch', modal).forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
        const nameEl = modal.querySelector('.qs-cname');
        if (nameEl) nameEl.textContent = sw.dataset.optval;
        if (carCtl) carCtl.filterColor(sw.dataset.optval);
        applyVariant(findVariant());
      });
    });

    $$('.qs-size-btn', modal).forEach(btn => {
      btn.addEventListener('click', () => {
        selOpts[parseInt(btn.dataset.optidx)] = btn.dataset.optval;
        $$('.qs-size-btn', modal).forEach(s => s.classList.remove('active'));
        btn.classList.add('active');
        applyVariant(findVariant());
      });
    });

    modal.querySelector('.qs-qty-minus')?.addEventListener('click', () => {
      if (qtyVal) qtyVal.textContent = Math.max(1, parseInt(qtyVal.textContent) - 1);
    });
    modal.querySelector('.qs-qty-plus')?.addEventListener('click', () => {
      if (qtyVal) qtyVal.textContent = parseInt(qtyVal.textContent) + 1;
    });

    modal.querySelector('.qs-atc')?.addEventListener('click', async function() {
      const vid = parseInt(this.dataset.variantId);
      const qty = parseInt(qtyVal?.textContent || '1', 10);
      this.disabled = true; this.textContent = 'Ajout...';
      await CartDrawer.addItem(vid, qty);
      close();
    });

    // COD: open the global SCOD modal in place with the previewed product
    modal.querySelector('.qs-cod')?.addEventListener('click', function() {
      if (!window.SCOD) { window.location.href = '/products/' + p.handle; return; }
      const v = findVariant();
      const images = (p.media || [])
        .filter(m => m.media_type === 'image').map(m => m.src);
      const imgs = images.length ? images : (p.images || []);
      const variants = p.variants.map(vv => ({
        id: vv.id,
        title: vv.public_title || vv.title,
        price: vv.price,
        available: inStock(vv),
        image: (vv.featured_image && vv.featured_image.src) || imgs[0] || p.featured_image || ''
      }));
      window.SCOD.open({ title: p.title, productId: p.id, images: imgs, variants: variants, pairs: pairs || [], selectedId: v.id });
      close();
    });
  }

  async function load(handle, galleryRaw, pairsRaw, swatchRaw) {
    open();
    const modal = getModal();
    if (!modal) return;
    const body = modal.querySelector('.qs-body');
    if (body) body.innerHTML = '<div style="padding:3rem;text-align:center;color:var(--muted)">Chargement...</div>';
    let galleryMap = null;
    if (galleryRaw) { try { galleryMap = JSON.parse(galleryRaw); } catch {} }
    let pairs = [];
    if (pairsRaw) { try { pairs = JSON.parse(pairsRaw) || []; } catch {} }
    let swatchMap = null;
    if (swatchRaw) { try { swatchMap = JSON.parse(swatchRaw); } catch {} }
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error();
      const p = await res.json();
      const cv = p.variants.find(inStock) || p.variants[0];
      if (body) { body.innerHTML = buildQS(p, cv, galleryMap, swatchMap); bindQS(p, galleryMap, pairs); }
    } catch {
      if (body) body.innerHTML = '<p style="padding:2rem;text-align:center">Erreur de chargement.</p>';
    }
  }

  function init() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.quickadd');
      if (!btn) return;
      const handle = btn.dataset.quickShop;
      if (handle) { e.preventDefault(); e.stopPropagation(); load(handle, btn.dataset.qsGallery, btn.dataset.qsPairs, btn.dataset.qsSwatches); }
    });
    document.addEventListener('click', e => {
      const modal = getModal();
      if (!modal) return;
      if (e.target === modal || e.target.closest('#qs-close, .qs-close')) close();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }
  return { init, open, close };
})();

/* -- Gift Note Modal ---------------------------------------- */
function openGiftNote() {
  const modal = $('#gift-note-modal');
  if (!modal) return;
  modal.classList.add('open');
  document.body.classList.add('modal-open');
  const saved = localStorage.getItem('sacluxe_gift_note') || '';
  const ta = $('#gn-textarea');
  const preview = $('#gn-preview');
  const counter = $('#gn-count');
  if (ta) ta.value = saved;
  if (preview) preview.textContent = saved || '';
  if (counter) counter.textContent = saved.length;
}
function closeGiftNote() {
  $('#gift-note-modal')?.classList.remove('open');
  document.body.classList.remove('modal-open');
}

const GiftNote = (() => {
  function save() {
    const msg = $('#gn-textarea')?.value || '';
    localStorage.setItem('sacluxe_gift_note', msg);
    const toggle = $('.gift-toggle .l');
    if (toggle) toggle.textContent = msg ? 'Message cadeau ajoute' : 'Ajouter un message cadeau';
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: msg })
    }).catch(() => {});
  }
  function init() {
    document.addEventListener('input', e => {
      if (e.target.id !== 'gn-textarea') return;
      const v = e.target.value;
      const preview = $('#gn-preview');
      if (preview) preview.textContent = v || '';
      const counter = $('#gn-count');
      if (counter) counter.textContent = v.length;
    });
    document.addEventListener('click', e => {
      const modal = $('#gift-note-modal');
      if (!modal) return;
      if (e.target === modal) { closeGiftNote(); CartDrawer.open(); return; }
      if (e.target.closest('#gn-close, .gn-close')) { closeGiftNote(); CartDrawer.open(); return; }
      if (e.target.closest('.gn-save')) { save(); closeGiftNote(); CartDrawer.open(); return; }
      if (e.target.closest('.gn-back')) { closeGiftNote(); CartDrawer.open(); return; }
    });
  }
  return { init };
})();

/* -- Accordions --------------------------------------------- */
const Accordions = (() => {
  function init() {
    document.addEventListener('click', e => {
      const head = e.target.closest('.acc-head');
      if (!head) return;
      head.closest('.acc')?.classList.toggle('open');
    });
  }
  return { init };
})();

/* -- Scroll Reveal ------------------------------------------ */
const Reveal = (() => {
  function init() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(el => el.classList.add('visible'));
      return;
    }
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  }
  return { init };
})();

/* -- WhatFits stagger --------------------------------------- */
const WhatFitsAnim = (() => {
  function init() {
    const wrap = $('.wf-wrap');
    if (!wrap) return;
    const items = $$('.wf-list li', wrap);
    if (!items.length) return;
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          items.forEach((li, i) => setTimeout(() => li.classList.add('visible'), i * 110));
          obs.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(wrap);
  }
  return { init };
})();

/* -- Product Card Slides ------------------------------------ */
const ProductCards = (() => {
  function bind(card) {
    const slides = $$('.slide', card);
    if (slides.length < 2) return;
    const dots = $$('.dots .d', card);
    let timer = null, cur = 0;
    function setSlide(idx) {
      slides.forEach((s, i) => s.classList.toggle('active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('on', i === idx));
      cur = idx;
    }
    function next() { setSlide((cur + 1) % slides.length); }
    function start() { stop(); timer = setInterval(next, 1800); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } setSlide(0); }
    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);

    const atcBtn = card.querySelector('.card-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();
        if (atcBtn.disabled) return;
        const vid = parseInt(atcBtn.dataset.variant, 10);
        if (!vid) return;
        const orig = atcBtn.textContent;
        atcBtn.disabled = true; atcBtn.textContent = '...';
        try { await CartDrawer.addItem(vid, 1); } catch {}
        atcBtn.disabled = false; atcBtn.textContent = orig;
      });
    }
  }
  function init() { $$('.product-card').forEach(bind); }
  return { init };
})();

/* -- Sticky Header ------------------------------------------ */
const StickyHeader = (() => {
  function init() {
    const h = $('.site-header');
    if (!h) return;
    const check = () => h.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
  return { init };
})();

/* -- Families carousel drag --------------------------------- */
const FamCarousel = (() => {
  function bind(rail) {
    let down = false, sx, sl;
    rail.addEventListener('mousedown', e => { down = true; sx = e.pageX - rail.offsetLeft; sl = rail.scrollLeft; rail.style.cursor = 'grabbing'; });
    rail.addEventListener('mouseleave', () => { down = false; rail.style.cursor = ''; });
    rail.addEventListener('mouseup', () => { down = false; rail.style.cursor = ''; });
    rail.addEventListener('mousemove', e => {
      if (!down) return;
      e.preventDefault();
      rail.scrollLeft = sl - (e.pageX - rail.offsetLeft - sx) * 1.5;
    });
    const wrap = rail.closest('.families-wrap');
    if (!wrap) return;
    wrap.querySelector('.fam-nav.prev')?.addEventListener('click', () => rail.scrollBy({ left: -340, behavior: 'smooth' }));
    wrap.querySelector('.fam-nav.next')?.addEventListener('click', () => rail.scrollBy({ left: 340, behavior: 'smooth' }));
  }
  function init() { $$('.families').forEach(bind); }
  return { init };
})();

/* -- Collection chips (client-side filter) ------------------ */
const CollChips = (() => {
  function init() {
    document.addEventListener('click', e => {
      const chip = e.target.closest('.chips .chip[data-cat]');
      if (!chip) return;
      e.preventDefault();
      $$('.chips .chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      const cat = chip.dataset.cat;
      $$('.grid-4 .product-card').forEach(card => {
        card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
      });
    });
  }
  return { init };
})();

/* -- Wishlist (localStorage) -------------------------------- */
const Wishlist = (() => {
  const KEY = 'sacluxe_wishlist';
  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  }
  function set(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
  /* Fold favorites saved under older key names into the unified list. */
  function migrateLegacy() {
    const legacyKeys = ['sac_wishlist', 'sacluxe_wishlist_' + (document.body.dataset.customerId || '')];
    let merged = get();
    let changed = false;
    legacyKeys.forEach(k => {
      const raw = localStorage.getItem(k);
      if (!raw) return;
      try {
        const old = JSON.parse(raw) || [];
        if (old.length) { merged = Array.from(new Set([...merged, ...old])); changed = true; }
      } catch {}
      localStorage.removeItem(k);
    });
    if (changed) set(merged);
  }
  function sync() {
    const list = get();
    $$('.wish').forEach(btn => {
      const h = btn.closest('[data-handle]')?.dataset.handle;
      if (h) btn.classList.toggle('on', list.includes(h));
    });
  }
  function init() {
    migrateLegacy();
    sync();
    document.addEventListener('click', e => {
      const btn = e.target.closest('.wish');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const h = btn.closest('[data-handle]')?.dataset.handle;
      if (!h) return;
      const list = get();
      const i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      set(list);
      btn.classList.toggle('on', i === -1);
    });
  }
  return { init };
})();

/* -- Variant Selector (PDP) --------------------------------- */
const VariantSel = (() => {
  function init() {
    const form = $('[data-product-form]');
    if (!form) return;

    const qtyMinus = $('#pdp-qty-minus');
    const qtyPlus = $('#pdp-qty-plus');
    const qtyVal = $('#pdp-qty-val');
    const qtyInput = form.querySelector('[name="quantity"]');

    function updateAtcLabel() {
      const btn = $('#product-atc');
      const priceEl = $('#product-price');
      if (!btn || !priceEl || !qtyVal) return;
      const cents = parseInt(priceEl.dataset.cents || '0', 10);
      const qty = parseInt(qtyVal.textContent, 10);
      btn.textContent = 'Ajouter au panier — ' + formatMAD(cents * qty);
    }

    if (qtyMinus && qtyPlus && qtyVal) {
      qtyMinus.addEventListener('click', () => {
        const v = Math.max(1, parseInt(qtyVal.textContent) - 1);
        qtyVal.textContent = v;
        if (qtyInput) qtyInput.value = v;
        updateAtcLabel();
      });
      qtyPlus.addEventListener('click', () => {
        const v = parseInt(qtyVal.textContent) + 1;
        qtyVal.textContent = v;
        if (qtyInput) qtyInput.value = v;
        updateAtcLabel();
      });
    }

    document.addEventListener('click', e => {
      const sw = e.target.closest('.swatch.lg[data-value]');
      if (!sw) return;
      const group = sw.closest('[data-option-group]');
      if (!group) return;
      $$('.swatch.lg', group).forEach(s => s.classList.remove('active'));
      sw.classList.add('active');
      const inp = group.querySelector('input[type=hidden]');
      if (inp) { inp.value = sw.dataset.value; }
      updateVariant();
    });

    function updateVariant() {
      const pd = window.__productData;
      if (!pd) return;
      const selected = {};
      $$('input[name^="option"]', form).forEach(inp => { selected[inp.name] = inp.value; });
      const v = pd.variants.find(vr => vr.options.every((o, i) => o === selected['option' + (i + 1)]));
      if (!v) return;
      const vidInp = form.querySelector('[name="id"]');
      if (vidInp) vidInp.value = v.id;
      const btn = $('#product-atc');
      if (btn) btn.disabled = !v.available;
      const priceEl = $('#product-price');
      if (priceEl) { priceEl.textContent = formatMAD(v.price); priceEl.dataset.cents = v.price; }
      updateAtcLabel();
      /* Gallery photos are filtered by colour in main-product.liquid (via the
         alt-text prefix), so no per-variant image swap is performed here. */
    }
  }
  return { init };
})();

/* -- Add to Cart (PDP) -------------------------------------- */
const AddToCart = (() => {
  function init() {
    const form = $('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('#product-atc');
      if (btn?.disabled) return;
      const fd = new FormData(form);
      const vid = parseInt(fd.get('id'), 10);
      const qty = parseInt(fd.get('quantity') || '1', 10);
      const orig = btn?.textContent || 'Ajouter au panier';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout...'; }
      await CartDrawer.addItem(vid, qty);
      if (btn) { btn.disabled = false; btn.textContent = orig; }
    });
  }
  return { init };
})();

/* -- Newsletter --------------------------------------------- */
const Newsletter = (() => {
  function init() {
    document.addEventListener('submit', async e => {
      const form = e.target.closest('.news form, .newsletter-form');
      if (!form) return;
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"], .news-btn');
      if (!input?.value) return;
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      const fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('customer[email]', input.value);
      fd.append('customer[tags]', 'newsletter');
      try {
        await fetch('/contact', { method: 'POST', body: fd });
        form.reset();
        const msg = form.querySelector('.news-msg');
        if (msg) msg.textContent = 'Merci ! Vous etes inscrit(e).';
      } catch {}
      if (btn) { btn.disabled = false; btn.textContent = "S'inscrire"; }
    });
  }
  return { init };
})();

/* -- Sort select (collection) ------------------------------- */
const SortSelect = (() => {
  function init() {
    const sel = $('#sort-select');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }
  return { init };
})();

/* -- Boot --------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  SearchOverlay.init();
  MobileMenu.init();
  QuickShop.init();
  GiftNote.init();
  Accordions.init();
  Reveal.init();
  WhatFitsAnim.init();
  ProductCards.init();
  StickyHeader.init();
  FamCarousel.init();
  CollChips.init();
  Wishlist.init();
  VariantSel.init();
  AddToCart.init();
  Newsletter.init();
  SortSelect.init();
  WelcomePopup.init();
  WishlistCount.init();
});

window.SacLuxe = { CartDrawer, QuickShop, refreshCart: () => CartDrawer.refresh() };

/* -- Route checkout to the custom COD form ------------------ */
/* Cart drawer + /cart page "Passer au paiement" open the COD modal (cart mode)
   instead of Shopify's native checkout. Falls back to native if SCOD missing. */
document.addEventListener('click', e => {
  const link = e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
  if (!link) return;
  if (window.SCOD && typeof window.SCOD.openCart === 'function') {
    e.preventDefault();
    try { CartDrawer.close(); } catch (_) {}
    window.SCOD.openCart();
  }
}, true);

/* -- Welcome Popup ------------------------------------------ */
const WelcomePopup = (() => {
  const STORAGE_KEY = 'sacluxe_popup_ts';
  const SESSION_KEY = 'sacluxe_popup_seen';

  function shouldShow(days) {
    if (document.body.classList.contains('template-customers')) return false;
    try {
      // Once shown in this tab session, never show again on any page
      if (sessionStorage.getItem(SESSION_KEY)) return false;
      const ts = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (ts && (Date.now() - ts) < days * 86400000) return false;
    } catch (e) {}
    return true;
  }

  function markShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  function openPopup(backdrop, tab) {
    backdrop.style.display = 'flex';
    requestAnimationFrame(() => backdrop.classList.add('visible'));
    if (tab) { tab.classList.remove('is-visible'); tab.setAttribute('aria-hidden', 'true'); }
  }

  function closePopup(backdrop, tab) {
    backdrop.classList.remove('visible');
    setTimeout(() => { backdrop.style.display = 'none'; }, 320);
    markShown(); // ensure recorded even if something skipped the open path
    if (tab) {
      setTimeout(() => {
        tab.classList.add('is-visible');
        tab.setAttribute('aria-hidden', 'false');
      }, 380); // slide in after backdrop fades out
    }
  }

  function init() {
    const backdrop = document.getElementById('wlc-backdrop');
    const tab      = document.getElementById('wlc-tab');
    if (!backdrop) return;

    const delay = parseInt(backdrop.dataset.delay || '2', 10) * 1000;
    const days  = parseInt(backdrop.dataset.days  || '7', 10);
    const code  = backdrop.dataset.code || 'BIENVENUE10';

    /* In the Shopify theme editor, always show immediately so the merchant
       can preview/approve it every time (bypass the once-per-session gate). */
    const designMode = !!(window.Shopify && window.Shopify.designMode);

    if (designMode || shouldShow(days)) {
      if (!designMode) markShown(); // mark immediately so navigating away still records it
      setTimeout(() => { openPopup(backdrop, tab); }, designMode ? 0 : delay);
    } else if (tab) {
      /* Popup already shown: slide tab in after a short pause */
      setTimeout(() => {
        tab.classList.add('is-visible');
        tab.setAttribute('aria-hidden', 'false');
      }, 1200);
    }

    /* Close handlers */
    document.getElementById('wlc-close')?.addEventListener('click', () => closePopup(backdrop, tab));
    backdrop.addEventListener('click', e => { if (e.target === backdrop) closePopup(backdrop, tab); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && backdrop.classList.contains('visible')) closePopup(backdrop, tab); });

    /* Tab re-open */
    document.getElementById('wlc-tab-open')?.addEventListener('click', () => openPopup(backdrop, tab));

    /* Tab dismiss — hides tab permanently for this session */
    document.getElementById('wlc-tab-dismiss')?.addEventListener('click', () => {
      if (tab) {
        tab.classList.remove('is-visible');
        tab.setAttribute('aria-hidden', 'true');
        tab.style.display = 'none';
      }
    });

    /* Step switcher (step 1 = capture, step 2 = reveal) */
    const step1 = document.getElementById('wlc-step1');
    const step2 = document.getElementById('wlc-step2');
    const modal = backdrop.querySelector('.wlc-modal');
    function goStep(n) {
      if (step1) step1.style.display = n === 1 ? 'block' : 'none';
      if (step2) step2.classList.toggle('active', n === 2);
      if (modal) modal.classList.toggle('is-step2', n === 2);
    }

    /* Step 1 — validate email, persist to Shopify, advance to reveal */
    const form    = document.getElementById('wlc-form');
    const emailEl = document.getElementById('wlc-email');
    const errEl   = document.getElementById('wlc-err');
    const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    form?.addEventListener('submit', async e => {
      e.preventDefault();
      const email = emailEl?.value.trim() || '';
      if (!EMAIL_RE.test(email)) {
        emailEl?.classList.add('is-error');
        errEl?.classList.add('show');
        emailEl?.focus();
        return;
      }
      emailEl?.classList.remove('is-error');
      errEl?.classList.remove('show');
      const btn = document.getElementById('wlc-submit');
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      const fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('customer[email]', email);
      fd.append('customer[tags]', 'newsletter,popup-10off');
      const intents = [...document.querySelectorAll('input[name="wlc_intent"]:checked')].map(i => i.value);
      if (intents.length) fd.append('customer[note]', 'Achète pour : ' + intents.join(', '));
      try { await fetch('/contact', { method: 'POST', body: fd }); } catch {}
      goStep(2);
    });

    /* Step 2 — gamified seal reveal */
    const seal     = document.getElementById('wlc-seal');
    const tapHint  = document.getElementById('wlc-tap-hint');
    const codeWrap = document.getElementById('wlc-codewrap');
    const revealSub = document.getElementById('wlc-reveal-sub');
    function reveal() {
      if (!seal || seal.classList.contains('broken')) return;
      seal.classList.add('broken');
      if (tapHint) tapHint.style.display = 'none';
      setTimeout(() => {
        seal.style.display = 'none';
        codeWrap?.classList.add('show');
        if (revealSub) revealSub.textContent = 'Votre code de bienvenue est prêt.';
      }, 420);
    }
    seal?.addEventListener('click', reveal);
    seal?.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });

    /* Copy discount code */
    const copyBtn  = document.getElementById('wlc-copy');
    const copyTxt  = document.getElementById('wlc-copytxt');
    if (copyBtn) {
      const doCopy = () => {
        navigator.clipboard?.writeText(code).catch(() => {});
        if (copyTxt) {
          const orig = copyTxt.textContent;
          copyTxt.textContent = 'Copié !'; copyTxt.classList.add('copied');
          setTimeout(() => { copyTxt.textContent = orig; copyTxt.classList.remove('copied'); }, 1800);
        }
      };
      copyBtn.addEventListener('click', doCopy);
      copyBtn.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doCopy(); } });
    }
  }

  /* Open the popup on demand (e.g. guest tries to use the wishlist). */
  function open() {
    const backdrop = document.getElementById('wlc-backdrop');
    if (!backdrop) return false;
    openPopup(backdrop, document.getElementById('wlc-tab'));
    markShown();
    return true;
  }

  return { init, open };
})();

/* -- Wishlist Count (header pip) ---------------------------- */
const WishlistCount = (() => {
  function update() {
    const pip = document.getElementById('wishlist-pip');
    if (!pip) return;
    let n = 0;
    try { n = (JSON.parse(localStorage.getItem('sacluxe_wishlist') || '[]')).length; } catch {}
    pip.textContent = n;
    pip.style.display = n ? '' : 'none';
  }
  function init() {
    update();
    document.addEventListener('click', e => {
      if (e.target.closest('.wish')) setTimeout(update, 0);
    });
  }
  return { init };
})();
